import React, { memo, MutableRefObject, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { wrapTrademarkSuperscript } from '../../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';
import { Button, Title } from '../../../importCL';
import { cleanNumericInput } from '../../../utils/income-utils';

export interface IIncomePopupProps {
    monthlyIncomeRef?: any;
    showPopup?: boolean;
    title?: string;
    subtitle?: string;
    successText?: string;
    cancelText?: string;
    successCallback?: () => void;
    cancelCallback?: () => void;
    setShowPopUp?: React.Dispatch<React.SetStateAction<boolean>>;
    setAnnualIncome?: React.Dispatch<React.SetStateAction<string>>;
    setMonthlyIncome?: React.Dispatch<React.SetStateAction<string>>;
    radioValue?: string;
    monthlyIncome?: string;
    annualIncome?: string;
}

const IncomePopup = memo(({
    monthlyIncomeRef: fwdRef,
    title,
    subtitle,
    successText,
    cancelText,
    setShowPopUp,
    radioValue,
    annualIncome,
    setAnnualIncome,
    monthlyIncome,
    setMonthlyIncome,
}: IIncomePopupProps) => {

    const handlePopupResult = useCallback((event: 'success' | 'canceled') => {
        if (event !== 'success') {
            setMonthlyIncome('');
            setAnnualIncome('');
        }
        setShowPopUp && setShowPopUp(false);
        fwdRef?.current?.focus();
    }, [
        setShowPopUp,
        setMonthlyIncome,
        setAnnualIncome,
    ]);

    const parsedSubHeadline = useMemo(() => {
        let nextSubtitle = subtitle;
        if (radioValue === 'yearly') {
            nextSubtitle = nextSubtitle
                ?.replaceAll('monthly', 'yearly')
                ?.replaceAll('{{income}}', '$' + annualIncome);
        } else {
            nextSubtitle = nextSubtitle
                ?.replaceAll('yearly', 'monthly')
                ?.replaceAll('{{income}}', '$' + monthlyIncome);
        }
        return transformHTMLParserLinks(wrapTrademarkSuperscript(nextSubtitle));
    }, [
        subtitle,
        radioValue,
        monthlyIncome,
        annualIncome,
    ]);

    const parsedTitle = useMemo(() => transformHTMLParserLinks(wrapTrademarkSuperscript(title || '')), [title]);
    const parsedSuccessText = useMemo(() => transformHTMLParserLinks(wrapTrademarkSuperscript(successText || '')), [successText]);
    const parsedCancelText = useMemo(() => transformHTMLParserLinks(wrapTrademarkSuperscript(cancelText || '')), [cancelText]);
    
    return (
        <>
            <div className='MonthlyIncome__popUpContainer'>
                <div className='MonthlyIncome__popUpContent'>
                    <Title className='MonthlyIncome__popUpClose' onClick={() => handlePopupResult('success')} >×</Title>
                    <Title className='MonthlyIncome__popUpHeadline' tag='h5'>{parsedTitle}</Title>
                    <p className='MonthlyIncome__popUpSubHeadline'>
                        {parsedSubHeadline}
                    </p>
                    <div className='MonthlyIncome__popUpButtons'>
                        <Button className='MonthlyIncome__popUpButton' onClick={() => handlePopupResult('success')} size='small' target='_self' variant='solid'>
                            {parsedSuccessText}
                        </Button>
                        <Button className='MonthlyIncome__popUpButton' onClick={() => handlePopupResult('canceled')} size='small' target='_self' variant='ghosted-dark'>
                            {parsedCancelText}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    );
});

export default IncomePopup;